import { billingErrorAccountStatusesByProviderSelector } from "./billingErrorAccountStatusesByProviderSelector";

import { RootState } from "../../../../store";
import { BillingAccountStatusWithProvider } from "../../../utils/types/types";
import { connectedProvidersSelector } from "../../connectedProvidersSelector";
import { ProviderType } from "../../../../../services/cloudchipr.api";

export const billingErrorAccountStatusesSelector = (
  state: RootState,
): BillingAccountStatusWithProvider[] => {
  const connectedProviders = connectedProvidersSelector(state);

  const billingStatusProviders = [
    ...connectedProviders,
    "eks",
    "confluent",
    "datadog",
    "snowflake",
    "mongo",
  ] as ProviderType[];

  return billingStatusProviders.reduce((result, provider) => {
    const data = billingErrorAccountStatusesByProviderSelector(state, provider);
    result = result.concat(data);

    return result;
  }, [] as BillingAccountStatusWithProvider[]);
};
